/** Calendar URLs, mirrored on the client so links render without a round-trip. */

export function publicCalendarUrlFor(calendarId: string): string {
  return `https://calendar.google.com/calendar/embed?src=${encodeURIComponent(calendarId)}`;
}

export function calendarSettingsUrlFor(calendarId: string): string {
  return `https://calendar.google.com/calendar/u/0/r/settings/calendar/${encodeURIComponent(calendarId)}`;
}
